import { useEffect } from "react"
import CardView from "./atoms/CardView"
import Filters from "./filters/filters"
import { loadEvents } from "../interfaces/eventInterface"
import { useDispatch, useSelector } from "react-redux"
import { clearEventsInfo } from "../features/rentSlice"
import PersistantRef from "./atoms/PersistantRef"
import { checkEqual } from "../helpers/helper"
import { Button , Row,Col} from "antd"
import { FormNavigator } from "../dynamicform/formNavigator";
import CenteredDisplay from "./atoms/CenteredContent"

const Events = () =>{
    const dispatch = useDispatch()
    const eventFilters = useSelector(state=>state.rent.eventFilters)
    const events = useSelector(state=>state.rent.events)
    const totalData = useSelector(state=>state.rent.events.totalData)
    const currentPage = useSelector(state=>state.rent.events.currentPage)

      const previousEventFilters = new PersistantRef(
    "previousEventFilters"
  );
  const formNavigator  = FormNavigator(dispatch)

    useEffect(()=>{
        loadEvents(dispatch,undefined,undefined,undefined,eventFilters)
    },[])

    useEffect(()=>{
        if (!checkEqual(eventFilters, previousEventFilters.getValue())) {
      dispatch(clearEventsInfo());
      loadEvents(dispatch,undefined,undefined,undefined,eventFilters)
      previousEventFilters.setValue(eventFilters);
    }

    },[eventFilters])
    const data = Object.values(events?.["data"]).flat() || [];
    return (
        <>
        <Row>
          <Col span={20}><Filters dispatch={dispatch} filterPage="events" values={eventFilters}/></Col>
          <Col span={4} className="m-auto "><Button className="float-right" size="small" onClick={()=>formNavigator.event()}>Create</Button></Col>
        </Row>
        {
        data && data.length == 0 && Object.keys(eventFilters).length == 0 ?
        <CenteredDisplay isLoading={!(data && data.length == 0 && Object.keys(eventFilters).length == 0)} title={"Events"} description={"Create a Event to Get Started"}  actionText={"Add"} actionCallback={()=>formNavigator.event()}/>
        :
        <CardView availablePages={new Set(Object.keys(events.data))} page={currentPage} data={data} filters={eventFilters} totalData={totalData} limit={25} config={'event'}/> }
        </>
    )

}

export default Events
